// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"329103d3","178":"ad84e949","294":"7380581e","300":"f312295a","312":"afa56476","329":"f018e01c","354":"2c8ff2e0","452":"f1e7d7ed","557":"46409ca1","672":"cee162ca","973":"a1ae1ace"}[chunkId] + ".chunk.js";
};